import React, { useEffect, useState } from 'react';
import { cacheSafeFetch } from './cacheSafeFetch';
import { GroupView } from './GroupView';
import { navigate } from './App';

export default function GroupPage() {
    const params = new URLSearchParams(window.location.search);
    const groupId = params.get('group_id') || params.get('group') || params.get('id');
    const zone = params.get('zone');
    const chatId = localStorage.getItem('chat_id');

    const [group, setGroup] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchGroup = async () => {
            try {
                setLoading(true);
                if (!groupId) {
                    setError('קבוצה לא נמצאה');
                    return;
                }
                if (!zone) {
                    setError('חסר מזהה אזור לצפייה בקבוצה');
                    return;
                }
                const res = await cacheSafeFetch(
                    `https://j1gefbe2q0.execute-api.us-west-2.amazonaws.com/default/get-zone-groups?zone_id=${zone}`,
                    chatId,
                    { method: 'GET' },
                    { cacheKey: `get-zone-groups-${zone}-${chatId}` }
                );
                const list = await res.json();
                const found = Array.isArray(list) ? list.find(g => (g.group_id || g.id) === groupId) : null;
                if (!found) {
                    setError('קבוצה לא נמצאה באזור');
                    return;
                }
                setGroup(found);
            } catch (e) {
                console.error('Failed to load group', e);
                setError('שגיאה בטעינת הקבוצה');
            } finally {
                setLoading(false);
            }
        };
        fetchGroup();
    }, [groupId, zone, chatId]);

    const handleBack = () => {
        if (document.referrer) {
            window.history.back();
        } else {
            if (zone) {
                navigate('zone-details', `zone=${zone}&tab=groups`);
            } else {
                navigate('zones');
            }
        }
    };

    if (loading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-surface-muted via-white to-brand-50/20 flex items-center justify-center">
                <div className="text-center">
                    <div className="w-12 h-12 border-4 border-brand-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
                    <p className="text-ink-subtle text-sm">טוען קבוצה...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-surface-muted via-white to-brand-50/20 flex items-center justify-center p-4">
                <div className="text-center">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-danger-100 flex items-center justify-center">
                        <span className="text-2xl">!</span>
                    </div>
                    <p className="text-danger-600 font-semibold mb-4">{error}</p>
                    <button
                        onClick={handleBack}
                        className="px-6 py-2.5 rounded-xl bg-brand-500 hover:bg-brand-600 text-white font-semibold transition-colors"
                    >
                        חזור
                    </button>
                </div>
            </div>
        );
    }

    if (!group) return null;

    return <GroupView group={group} chatId={chatId} zone={zone} onClose={handleBack} showHeader={true} />;
}
